
// brand colors
export const BASE_COLORS = {
    azul: '#050B29',
    azulClaro: '#1976d2',
    loginButton: '#3394EF',
    vermelho: '#B31417',
    branco: '#FFFFFF',
    cinzaClaro: '#F6F6F6',
    cinzaEscuro: '#3A3A3A',
    cinzaDesbotado: '#e6e6e6',
    primaria: '#8DBADF2B',
    primariaEscura: '#3394EF',
    secundaria: '#3ACDB41A',
    secundariaEscura: '#3acdb4',
    botaoFormulario: '#3394EF',
}

const DEV_COLORS = {
    ...BASE_COLORS,
}

const PALHOCA_COLORS = {
    ...BASE_COLORS,
    primaria: '#8DBADF2B',
    secundaria: '#8DBADF2B',
    primariaEscura: '#2389CA',
    secundariaEscura: '#2389CA',
}

const PAULODEFRONTIN_COLORS = {
    ...BASE_COLORS,
    primaria: '#8DBADF2B',
    secundaria: '#8DBADF2B',
    primariaEscura: '#2389CA',
    secundariaEscura: '#2389CA',
}

const FINEP_COLORS = {
    ...BASE_COLORS,
    primaria: '#F165232B',
    primariaEscura: '#016361',
    secundariaEscura: '#F16523',
    secundaria: '#F165232B',
    loginButton: '#F16523',
    botaoFormulario: '#F16523',
}

const PROCON_COLORS = {
    ...BASE_COLORS,
    primaria: '#8DBADF2B',
    secundaria: '#8DBADF2B',
    primariaEscura: '#014E9B',
    secundariaEscura: '#014E9B',
}

const BADESUL_COLORS = {
    ...BASE_COLORS,
    primaria: '#08491F2B',
    secundaria: '#08491F2B',
    primariaEscura: '#08491F',
    secundariaEscura: '#08491F',
    loginButton: '#08491F',
    botaoFormulario: '#08491F',
}

const TRE_MT_COLORS = {
    ...BASE_COLORS,
    primaria: '#2532B22B',
    secundaria: '#2532B22B',
    primariaEscura: '#2532B2',
    secundariaEscura: '#2532B2',
    loginButton: '#2532B2',
    botaoFormulario: '#2532B2',
}

const FLORIANOPOLIS_COLORS = {
    ...BASE_COLORS,
    primaria: '#01BAF22B',
    secundaria: '#01BAF22B',
    primariaEscura: '#01BAF2',
    secundariaEscura: '#01BAF2',
    loginButton: '#01BAF2',
    botaoFormulario: '#01BAF2',
}

const PALMAS_COLORS = {
    ...BASE_COLORS,
    primaria: '#0022662B',
    secundaria: '#0022662B',
    primariaEscura: '#002266',
    secundariaEscura: '#002266',
    loginButton: '#002266',
    botaoFormulario: '#002266',
}

const PCSP_COLORS = {
    ...BASE_COLORS,
    primaria: '#B5A75A2B',
    secundaria: '#B5A75A2B',
    primariaEscura: '#B5A75A',
    secundariaEscura: '#B5A75A',
    loginButton: '#B5A75A',
    botaoFormulario: '#B5A75A',
}

const CREA_SC_COLORS = {
    ...BASE_COLORS,
    primaria: '#004C932B',
    secundaria: '#004C932B',
    primariaEscura: '#004C93',
    secundariaEscura: '#004C93',
    loginButton: '#004C93',
    botaoFormulario: '#004C93',
}

const DPMT = {
    ...BASE_COLORS,
    primaria: '#17603826',
    secundaria: '#17603826',
    primariaEscura: '#176038',
    secundariaEscura: '#176038',
    loginButton: '#176038',
    botaoFormulario: '#176038',
}

const CINDERONDONIA_COLORS = {
    ...BASE_COLORS,
    primaria: '#06324726',
    secundaria: '#06324726',
    primariaEscura: '#1E4721',
    secundariaEscura: '#1E4721',
    loginButton: '#1E4721',
    botaoFormulario: '#1E4721',
}

const GOIASFOMENTO_COLORS = {
    ...BASE_COLORS,
    primaria: '#06324726',
    secundaria: '#06324726',
    primariaEscura: '#C78A3E',
    secundariaEscura: '#C78A3E',
    loginButton: '#C78A3E',
    botaoFormulario: '#C78A3E',
}

const PORTOBELO_COLORS = {
    ...BASE_COLORS,
    primaria: '#2532B22B',
    secundaria: '#2532B22B',
    primariaEscura: '#02799F',
    secundariaEscura: '#02799F',
    loginButton: '#02799F',
    botaoFormulario: '#02799F',
}

const TIJUCAS_COLORS = {
    ...BASE_COLORS,
    primaria: '#2532B22B',
    secundaria: '#2532B22B',
    primariaEscura: '#333333',
    secundariaEscura: '#333333',
    loginButton: '#333333',
    botaoFormulario: '#333333',
}

const JARAGUADOSUL_COLORS = {
    ...BASE_COLORS,
    primaria: '#8AAA292B',
    secundaria: '#8AAA292B',
    primariaEscura: '#8AAA29',
    secundariaEscura: '#8AAA29',
    loginButton: '#8AAA29',
    botaoFormulario: '#8AAA29',
}

const CBM_RN_COLORS = {
    ...BASE_COLORS,
    primaria: '#ED32372B',
    secundaria: '#ED32372B',
    primariaEscura: '#ED3237',
    secundariaEscura: '#ED3237',
    loginButton: '#ED3237',
    botaoFormulario: '#ED3237',
}

const CORUPA_COLORS = {
    ...BASE_COLORS,
    primaria: '#494C4F2B',
    secundaria: '#494C4F2B',
    primariaEscura: '#494C4F',
    secundariaEscura: '#494C4F',
    loginButton: '#494C4F',
    botaoFormulario: '#494C4F',
}

const SMCSP_COLORS = {
    ...BASE_COLORS,
    primaria: '#D9261C2B',
    secundaria: '#D9261C2B',
    primariaEscura: '#D9261C',
    secundariaEscura: '#D9261C',
    loginButton: '#D9261C',
    botaoFormulario: '#D9261C',
}

const SMCSP_CULTURA_COLORS = {
    ...SMCSP_COLORS,
    primaria: '#7B2CBF2B',
    secundaria: '#7B2CBF2B',
    primariaEscura: '#7B2CBF',
    secundariaEscura: '#7B2CBF',
}

const PRODESP_COLORS = {
    ...BASE_COLORS,
    primaria: '#5008782B',
    secundaria: '#5008782B',
    primariaEscura: '#500878',
    secundariaEscura: '#500878',
    loginButton: '#500878',
    botaoFormulario: '#500878',
}

const CREA_PR_COLORS = {
    ...BASE_COLORS,
    primaria: '#004C932B',
    secundaria: '#004C932B',
    primariaEscura: '#004C93',
    secundariaEscura: '#004C93',
    loginButton: '#004C93',
    botaoFormulario: '#004C93',
}

const ITAJAI_COLORS = {
    ...BASE_COLORS,
    primaria: '#222D5A2B',
    secundaria: '#222D5A2B',
    primariaEscura: '#222D5A',
    secundariaEscura: '#222D5A',
    loginButton: '#222D5A',
    botaoFormulario: '#222D5A',
}

const SEFAZ_SP_COLORS = {
    ...BASE_COLORS,
    primaria: '#D9261C2B',
    secundaria: '#D9261C2B',
    primariaEscura: '#D9261C',
    secundariaEscura: '#D9261C',
    loginButton: '#D9261C',
    botaoFormulario: '#D9261C', 
}

const SCPAR_COLORS = {
    ...BASE_COLORS,
    primaria: '#2A9CC22B',
    secundaria: '#2A9CC22B',
    primariaEscura: '#2A9CC2',
    secundariaEscura: '#2A9CC2',
    loginButton: '#2A9CC2',
    botaoFormulario: '#2A9CC2', 
}

const EMERJ_COLORS = {
    ...BASE_COLORS,
    primaria: '#10344F2B',
    secundaria: '#10344F2B',
    primariaEscura: '#10344F',
    secundariaEscura: '#10344F',
    loginButton: '#10344F',
    botaoFormulario: '#10344F',
}

const MANGARATIBA_COLORS = {
    ...BASE_COLORS,
    primaria: '#064EA52B',
    secundaria: '#064EA52B',
    primariaEscura: '#064EA5',
    secundariaEscura: '#064EA5',
    loginButton: '#064EA5',
    botaoFormulario: '#064EA5',
}

const SAOBENTODOSUL_COLORS = {
    ...BASE_COLORS,
    primaria: '#007B3D2B',
    secundaria: '#007B3D2B',
    primariaEscura: '#007B3D',
    secundariaEscura: '#007B3D',
    loginButton: '#007B3D',
    botaoFormulario: '#007B3D',
}

const SEBRAE_COLORS = {
    ...BASE_COLORS,
    primaria: '#064EA52B',
    secundaria: '#064EA52B',
    primariaEscura: '#064EA5',
    secundariaEscura: '#064EA5',
    loginButton: '#064EA5',
    botaoFormulario: '#064EA5',
}

const SUBDOMAIN_THEMES: {[key: string]: typeof BASE_COLORS} = {
    dev: DEV_COLORS,
    palhoca: PALHOCA_COLORS,
    paulodefrontin: PAULODEFRONTIN_COLORS,
    finep: FINEP_COLORS,
    procon: PROCON_COLORS,
    badesul: BADESUL_COLORS,
    'tre-mt': TRE_MT_COLORS,
    florianopolis: FLORIANOPOLIS_COLORS,
    palmas: PALMAS_COLORS,
    pcsp: PCSP_COLORS,
    'crea-sc': CREA_SC_COLORS,
    dpemt: DPMT,
    cinderondonia: CINDERONDONIA_COLORS,
    goiasfomento: GOIASFOMENTO_COLORS,
    portobelo: PORTOBELO_COLORS,
    tijucas: TIJUCAS_COLORS,
    jaraguadosul: JARAGUADOSUL_COLORS,
    'cbm-rn': CBM_RN_COLORS,
    corupa: CORUPA_COLORS,
    'smculturasp': SMCSP_COLORS,
    prodesp: PRODESP_COLORS,
    'crea-pr': CREA_PR_COLORS,
    itajai: ITAJAI_COLORS,
    sefazsp: SEFAZ_SP_COLORS,
    scpar: SCPAR_COLORS,
    emerj: EMERJ_COLORS,
    mangaratiba: MANGARATIBA_COLORS,
    saobentodosul: SAOBENTODOSUL_COLORS,
    sebrae: SEBRAE_COLORS,
}



const ORGANIZATION_DEFAULT_URL_KEY = 'organizationDefaultUrl'

function subdomainOf(hostname: string) {
    const parts = hostname.split('.')
    return parts.length > 2 ? parts[0] : null
}

// default_url da organização (white-label, vem do /users) vence o host acessado
export function getSubdomain() {
    try {
        const defaultUrl = localStorage.getItem(ORGANIZATION_DEFAULT_URL_KEY)
        if (defaultUrl) {
            // texto livre no core: pode vir sem esquema
            const url = defaultUrl.includes('://') ? defaultUrl : `https://${defaultUrl}`
            const subdomain = subdomainOf(new URL(url).hostname)
            if (subdomain) return subdomain
        }
    } catch {
        // localStorage indisponível ou default_url inválido: segue pelo host
    }
    return subdomainOf(window.location.hostname)
}

// Grava (ou limpa) o default_url da organização. Retorna true se o tenant mudou:
// cores, logos e tema são lidos no carregamento dos módulos, então é preciso recarregar.
export function setOrganizationDefaultUrl(defaultUrl?: string | null): boolean {
    const before = getSubdomain()
    try {
        const value = defaultUrl?.trim()
        if (value) localStorage.setItem(ORGANIZATION_DEFAULT_URL_KEY, value)
        else localStorage.removeItem(ORGANIZATION_DEFAULT_URL_KEY)
    } catch {
        return false
    }
    return getSubdomain() !== before
}

export type Area = 'licitacao' | 'cultura'

const AREA_KEYS = [
    'primaria',
    'secundaria',
    'primariaEscura',
    'secundariaEscura',
] as const

export const hasAreas = () => getSubdomain() === 'smculturasp'

export function applyArea(area: Area) {
    if (!hasAreas()) return
    const colors = area === 'cultura' ? SMCSP_CULTURA_COLORS : SMCSP_COLORS
    AREA_KEYS.forEach((key) =>
        document.documentElement.style.setProperty(`--${key}`, colors[key])
    )
}

applyArea('licitacao')

export function getCurrentColors() {
    const subdomain = getSubdomain()
    if (hasAreas()) {
        return {
            ...SMCSP_COLORS,
            ...Object.fromEntries(AREA_KEYS.map((k) => [k, `var(--${k})`])),
        }
    }
    if (subdomain && SUBDOMAIN_THEMES[subdomain]) {
        console.log(
            `Subdomínio detectado: ${subdomain}. Usando tema específico.`
        )
        return SUBDOMAIN_THEMES[subdomain]
    }
    console.log(
        'Nenhum subdomínio específico ou tema encontrado. Usando cores padrão.'
    )
    return BASE_COLORS
}
